import React from 'react';
import classes from './TNEDashboardHeader.module.scss';
import TNEFilters from '../Filters/TNEFilters/TNEFilters';

export default function TNEDashboardHeader(props) {
  const { title, filters, values, changeHandlers, part } = props;

  return (
    <div className={classes.header}>
      <h1 className={classes.title}>{title}</h1>
      <TNEFilters filters={filters} values={values} changeHandlers={changeHandlers} part={part} />
    </div>
  );
}
